import { useEffect, useRef, useState } from 'react';

import { CardLayoutComponent } from '@workinance/shared/ui/CardLayoutComponent';
import { BellIcon } from '@workinance/shared/ui/icons';

/**
 * The notifications button in every app's top bar. There is no notifications feed yet, so the panel says so;
 * when one exists, its items (and an unread dot on the bell) belong here.
 */
export function NotificationBellComponent() {
	const [isOpen, setIsOpen] = useState(false);
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!isOpen) return;

		function handleClickOutside(event: MouseEvent) {
			if (
				containerRef.current &&
				!containerRef.current.contains(event.target as Node)
			) {
				setIsOpen(false);
			}
		}
		function handleEscape(event: KeyboardEvent) {
			if (event.key === 'Escape') setIsOpen(false);
		}

		document.addEventListener('mousedown', handleClickOutside);
		document.addEventListener('keydown', handleEscape);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
			document.removeEventListener('keydown', handleEscape);
		};
	}, [isOpen]);

	return (
		<div ref={containerRef} className="relative">
			<button
				type="button"
				aria-label="Notifications"
				aria-expanded={isOpen}
				onClick={() => setIsOpen((open) => !open)}
				className="grid size-10 cursor-pointer place-items-center rounded-full border border-rule bg-panel text-ink transition-colors hover:bg-brand-soft"
			>
				<BellIcon className="size-4.5" />
			</button>

			{isOpen ? (
				<CardLayoutComponent className="absolute top-full right-0 z-50 mt-2 w-80 max-w-[calc(100vw-2rem)] overflow-hidden rounded-3xl shadow-xl">
					<p className="border-b border-dashed border-rule px-5 py-4 font-bold">
						Notifications
					</p>
					<div className="flex flex-col items-center px-5 py-8 text-center">
						<span className="grid size-11 place-items-center rounded-full bg-brand-soft text-brand">
							<BellIcon className="size-5" />
						</span>
						<p className="mt-3 font-semibold">You're all caught up</p>
						<p className="mt-1 text-sm text-mute">
							Alerts such as low stock and unpaid sales will show here.
						</p>
					</div>
				</CardLayoutComponent>
			) : null}
		</div>
	);
}
